"use strict";
var ChartEvent = (function () {
    function ChartEvent(event, context) {
        this.originalEvent = event;
        this.context = context;
    }
    return ChartEvent;
}());
exports.ChartEvent = ChartEvent;
//# sourceMappingURL=ChartEvent.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/angular2-highcharts/dist/ChartEvent.js
// module id = ../../../../angular2-highcharts/dist/ChartEvent.js
// module chunks = vendor